import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChange, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ServicecallService } from 'src/app';
import { EntityListPayloadModel } from 'src/app/model';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { CaseServiceService } from 'src/app/modules/case/case-service.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { masterConfigurationList } from 'src/app/constants/masterConfigList';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ProtusServiceService } from 'src/app/modules/protus/protus-service.service';

@Component({
  selector: 'app-add-protus-popover',
  templateUrl: './add-protus-popover.component.html',
  styleUrl: './add-protus-popover.component.css'
})
export class AddProtusPopoverComponent implements OnInit, OnDestroy {

  @Input() isCollapsed: boolean;
  @Input() dtcDetails: any;
  @Input() formType: string;
  @Input() protusDetails: any;
  @Input() pageType: string;
  @Input() chassisNumbers: {name: StaticRange, value: string}[];

  @Output() collapse = new EventEmitter<any>();

  addProtusFormFirst: FormGroup;
  addProtusFormSecond: FormGroup;
  projectId = new FormControl('', [Validators.required]);
  modelIds = new FormControl('', [Validators.required]);
  description = new FormControl('', [Validators.required]);
  currentStep: number = 0;
  projectsNameList: { value: string, name: string, State: string, id: string }[] = [];
  trackingProjectsList: { name: string, value: string }[] = [];
  ncTypeList: { name: string, value: string }[] = [];
  affectedAggregatesList: { name: string, value: string }[] = [];
  testTypeList: { name: string, value: string }[] = [];
  testObjectTypeList: { value: string, name: string }[] = [];
  incidentCategoryList: { value: string, name: string }[] = [];
  modelsList: { name: string, value: string, id: string }[] = [];
  correctProcessUsedList: { value: string, name: string }[] = [];
  toolPartVerificationList: { value: string, name: string }[] = [];
  faultPointMapping: { severity: string, value: string }[] = [];
  tenantConfig: any = {};
  listingDetails: any;
  searchTermProject: any = null;
  searchTermModel: any = null;
  file: File | null = null;
  teleHistoryConfig: any = {};
  faultPoint: number;
  isLoaderModelNo: boolean = true;
  isLoaderProjectName: boolean = true;
  isLoderChassisNo : boolean = true;
  translatedText = '';
  fileTypes: string[] = [];
  maxDate: Date = new Date();

  @ViewChild('errorDialog') errorDialogTemplate!: TemplateRef<any>;

  // report reoccurence
  reportReoccurenceForm: FormGroup;
  remarksList: any[] = [];
  protusList: any[] = [];
  private _protusReoccurenceSubscription: Subscription;
  private _selectedProtusDetails: any;

  private _idmConfig: any = {};
  private _configUpdated: boolean = false;
  private _entitiesListSubscription: Subscription;
  private _getModelsListSubscription: Subscription;
  private _getProjectListSubsription: Subscription;
  private _addProtusSubscription: Subscription;
  private _configUpdateSubscription: Subscription;
  private _configurationsInfoSubscription: Subscription;

  constructor(private _fb: FormBuilder, private _caseService: CaseServiceService, private _service: ServicecallService, private _datePipe: DatePipe, private translate: TranslateService, private dialog: MatDialog, private _protusService: ProtusServiceService) {
    this.addProtusFormFirst = this._fb?.group({
      'Project': ['', Validators.required],
      'Sub Project': ['', Validators.required],
      'Chassis No': [{ value: '', disabled: true }],
      'Vehicle Name': [{ value: '', disabled: true }],
      'Incident Related WheelBase': [{ value: '', disabled: true }],
      'Release Build': [{ value: '', disabled: true }],
      'Build Number': [{ value: '', disabled: true }],
    });
    this.addProtusFormSecond = this._fb?.group({
      'Incident Date': [{ value: '', disabled: true }, Validators.required],
      'NCType': ['', Validators.required],
      'Fault Point': ['', Validators.required],
      'VECV_AggregateDetails': ['', Validators.required],
      'Part Name': ['', Validators.required],
      'Test Type': ['', Validators.required],
      'Related Object Type': ['', Validators.required],
      'Incident Category': ['', Validators.required],
      'Correct Process Used': ['', Validators.required],
      'Process Remarks': ['', Validators.required],
      'Tool & Part Verification Done': ['', Validators.required],
      'Verification Remarks': ['', Validators.required],
    });
    this.reportReoccurenceForm = this._fb?.group({
      'protusId': ['', Validators.required],
      'buildType': ['', Validators.required],
      'buildNumber': ['', Validators.required],
      'remarks': [''],
      'reoccuranceInfo': ['', Validators.required],
      'reoccurenceVehicalNumber': ['', Validators.required]
    });
  }

  ngOnChanges(changes: SimpleChange) {
    if (this.formType === 'reoccurence') {
      if (this.protusDetails?.length) {
        this.protusDetails?.forEach((item: any) => {
          this.protusList.push({
            name: item?.name,
            value: item?.id
          })
        });
      }
      this.initializeReoccurenceForm();
    }
    if(this.pageType === 'addNewProtus') {
      this.addProtusFormFirst?.get('Chassis No')?.enable();
      this.addProtusFormFirst?.controls['Chassis No']?.setValidators([Validators.required]);
      this.addProtusFormSecond?.get('Incident Date')?.enable();
      this.addProtusFormSecond?.controls['Incident Date']?.setValidators([Validators.required]);
    }
    if(changes['chassisNumbers']) {
      this.isLoderChassisNo = false;
    }
  }

  ngOnInit() {
    this._idmConfig = this._service.getConfiguration('idmConfig') ? this._service.getConfiguration('idmConfig') : null;
    this.tenantConfig = this._service.getConfiguration('tenantGenericConfig') ? this._service.getConfiguration('tenantGenericConfig') : null;
    this.fileTypes = this._service.getConfiguration('fileTypes') ? this._service.getConfiguration('fileTypes')?.fileTypes : [];
    if (this.formType === 'reoccurence') {
      this.remarksList = this._idmConfig?.reportReoccurrenceFieldValues ? this._idmConfig?.reportReoccurrenceFieldValues?.remarks : [{
        "value": "Aggregate made in EDC",
        "name": "Aggregate made in EDC"
      }]
    } else {
      this._getModelsList();
      this._getProjectsList();
      this.teleHistoryConfig = this._service.getConfigurationBasedOnCategory(this.dtcDetails) ?
        this._service.getConfigurationBasedOnCategory(this.dtcDetails) : [];
      if(this.pageType !== 'addNewProtus') {
        this._getEntityDetails(1);
      }
      this._setDropDownValuesFromConfig();
      this.fetchProtusTitle();
    }
  }

  ngOnDestroy() {
    this._entitiesListSubscription?.unsubscribe();
    this._getProjectListSubsription?.unsubscribe();
    this._getModelsListSubscription?.unsubscribe();
    this._addProtusSubscription?.unsubscribe();
    this._configUpdateSubscription?.unsubscribe();
    this._configurationsInfoSubscription?.unsubscribe();
    this._protusReoccurenceSubscription?.unsubscribe();
  }

  get acceptTypes(): string {
    return this.fileTypes
      ?.map(type => type?.startsWith('.') ? type : `.${type}`)
      ?.join(',');
  }

  /**
 * Initializes form
 */
  initializeReoccurenceForm() {
    if (this.protusList?.length === 1) {
      this.reportReoccurenceForm?.get('protusId')?.setValue(this.protusList?.[0]?.value);
      this.onProtusSelection(this.protusList?.[0]);
    }
    this.reportReoccurenceForm?.get('reoccurenceVehicalNumber')?.setValue(this.dtcDetails?.uniqueId);
    this.reportReoccurenceForm?.get('reoccurenceVehicalNumber')?.disable();
  }

  /**
 * Attachs to protus
 */
  attachToProtus() {
    const formData = new FormData();
    const formValues = this.reportReoccurenceForm?.getRawValue();
    formData?.append('buildType', formValues?.buildType);
    formData?.append('buildNumber', formValues?.buildNumber);
    formData?.append('reoccuranceInfo', formValues?.reoccuranceInfo);
    formData?.append('reoccurenceVehicalNumber', formValues?.reoccurenceVehicalNumber);
    formData?.append('remarks', formValues?.remarks);
    formData?.append('file', this.file);
    formData?.append('caseId', this.dtcDetails?.caseId);
    this._protusReoccurenceSubscription = this._protusService?.protusReoccurence(formData, this._selectedProtusDetails?.id)?.subscribe({
      next: (result: any) => {
        if (result) {
          this.handleClose(false, result?.['ProjectId'], result?.name);
          this._service.toasterService({ type: 'success', msg: result?.message });
        }
      }
    })
  }

  /**
 * Determines whether protus selection on
 * @param protus 
 */
  onProtusSelection(protus: MatSelectChange) {
    this._selectedProtusDetails = this.protusDetails?.find(item => item?.id === protus?.value);
    this.reportReoccurenceForm?.get('buildType')?.setValue(this._selectedProtusDetails?.['Release Build']);
    this.reportReoccurenceForm?.get('buildNumber')?.setValue(this._selectedProtusDetails?.['Build Number']);
    this.reportReoccurenceForm?.get('buildType')?.disable();
    this.reportReoccurenceForm?.get('buildNumber')?.disable();
  }

  /**
   * Fetchs protus number title dynamically using translation
   * @returns  
   */
  fetchProtusTitle() {
    const key = 'protusNumber';
    const translation = this.translate.instant(key);
    this.translatedText = (translation && translation !== key) ? translation : 'Protus';
  }

  /**
   * Gets selected option
   * @param fieldName 
   * @returns  
   */
  getSelectedOption(fieldName: string) {
    if (fieldName === 'projectsName') {
      return this.projectId?.value ? this.projectsNameList?.find(project => project?.value === this.projectId?.value) : null;
    } else if (fieldName === 'modelNo') {
      return this.modelIds?.value ? this.modelsList?.find(model => model?.value === this.modelIds?.value) : null;
    } else if (fieldName === 'subProject') {
      return this.addProtusFormFirst?.get('Sub Project')?.value ? this.trackingProjectsList?.find(trackingProject => trackingProject?.value === ((this.addProtusFormFirst?.get('Sub Project')?.value))) : null;
    } else if (fieldName === 'NCType') {
      return this.addProtusFormSecond?.get('NCType')?.value ? this.ncTypeList?.find(ncType => ncType?.value === ((this.addProtusFormSecond?.get('NCType')?.value))) : null;
    } else if (fieldName === 'VECV_AggregateDetails') {
      return this.addProtusFormSecond?.get('VECV_AggregateDetails')?.value ? this.affectedAggregatesList?.find(affectedAggregate => affectedAggregate?.value === ((this.addProtusFormSecond?.get('VECV_AggregateDetails')?.value))) : null;
    } else if (fieldName === 'testType') {
      return this.addProtusFormSecond?.get('Test Type')?.value ? this.testTypeList?.find(testType => testType?.value === ((this.addProtusFormSecond?.get('Test Type')?.value))) : null;
    } else if (fieldName === 'incidentCategory') {
      return this.addProtusFormSecond?.get('Incident Category')?.value ? this.incidentCategoryList?.find(incidentCategory => incidentCategory?.value === ((this.addProtusFormSecond?.get('Incident Category')?.value))) : null;
    } else if (fieldName === 'testObjectType') {
      return this.addProtusFormSecond?.get('Related Object Type')?.value ? this.testObjectTypeList?.find(testObjectType => testObjectType?.value === ((this.addProtusFormSecond?.get('Related Object Type')?.value))) : null;
    } else if(fieldName === 'Chassis No') {
      return this.addProtusFormFirst?.get('Chassis No')?.value ? this.chassisNumbers?.find(item => item?.name === ((this.addProtusFormFirst?.get('Chassis No')?.value))) : null;
    } else {
      return null;
    }
  }

  onVirtualScrollValueSelection(type: string, option: any) {
    switch (type) {
      case 'projectName':
        this.projectId?.setValue(option?.value);
        this.addProtusFormFirst?.get('Project')?.setValue(option?.name);
        break;
      case 'subProject':
        this.addProtusFormFirst?.get('Sub Project')?.setValue(option?.value);
        break;
      case 'modelId':
        this.modelIds?.setValue(option?.value);
        break;
      case 'NCType':
        this.addProtusFormSecond?.get('NCType')?.setValue(option?.value);
        break;
      case 'VECV_AggregateDetails':
        this.addProtusFormSecond?.get('VECV_AggregateDetails')?.setValue(option?.value);
        break;
      case 'testType':
        this.addProtusFormSecond?.get('Test Type')?.setValue(option?.value);
        break;
      case 'incidentCategory':
        this.addProtusFormSecond?.get('Incident Category')?.setValue(option?.value);
        break;
      case 'testObjectType':
        this.addProtusFormSecond?.get('Related Object Type')?.setValue(option?.value);
        break;
      case 'Chassis No':
        this.addProtusFormFirst?.get('Chassis No')?.setValue(option?.value);
        this._getEntityDetails(1);
        break;
      default:
        break;
    }
  }

  /**
   * Exports telemetry data
   */
  exportTelemetryData() {
    let startDate;
    let endDate;
    startDate = new Date(this.dtcDetails?.metadata?.createdDate);
    endDate = this.getDate7DaysForward(this.dtcDetails?.metadata?.createdDate);
    const reqParam = {
      from: this._datePipe?.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe?.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.dtcDetails?.entityId,
      exportFormat: 'csv',
      timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
      exportFilename: 'Telematics History',
      fields: this._service.getConfigurationBasedOnCategory(this.dtcDetails, 'export') ?
      this._service.getConfigurationBasedOnCategory(this.dtcDetails, 'export')?.export?.telematicsHistory : []
    }
    this._service.commonExport('csv', reqParam, 'activeEntityExport', 'Export_Telematics_History_')
  }

  /**
     * Handles close
     * @param isClosed 
     */
  handleClose (isClosed: boolean, protusNumber?: string, protusName?: string) {
    this.collapse?.emit((protusNumber || protusName) ? { isClosed: isClosed, protusNumber: protusNumber, protusName: protusName } : isClosed);
  }

  /**
   * Go to next
   */
  goToNext() {
    this.currentStep = 1;
  }

  /**
   * Go to previous
   */
  goToPrevious() {
    this.currentStep = 0;
  }

  /**
   * Uploads file
   * @param event 
   */
  uploadFile(event: any) {
    const input = event.target as HTMLInputElement;
    if (!input?.files || input?.files?.length === 0) return;
  
    const allowedExtensions = Array.from(
      new Set(this.fileTypes?.map(ft => ft?.toLowerCase()))
    );
    const file = input.files[0];
    const ext = file?.name?.split('.')?.pop()?.toLowerCase();

    if (!ext || !allowedExtensions?.includes(ext)) {
      this.openErrorDialog(`Allowed file types: ${allowedExtensions?.join(', ')}`);
      input.value = '';
      return;
    } else {
      if (event?.target?.files?.length > 0) {
        this.file = event?.target?.files?.[0];
      }
    }
  }

  openErrorDialog(message: string): void {
    this.dialog.open(this.errorDialogTemplate, { data: message, width: '300px' });
  }

  /**
   * Adds protus
   */
  addProtus() {
    const formData = new FormData();
    formData?.append('isMock', this._idmConfig?.isMock ? this._idmConfig?.isMock : false);
    formData?.append('ModelIds', this.modelIds?.value);
    formData?.append('Description', this.description?.value);
    formData?.append('ProjectId', this.projectId?.value);
    const incidentDate: Date = this.addProtusFormSecond?.get('Incident Date')?.value;
    const formattedIncidentDate = new DatePipe('en-US').transform(incidentDate, 'MM/dd/yyyy');
    this.pageType !== 'addNewProtus' && formData?.append('caseId', this.dtcDetails?.caseId);
    formData?.append('username', localStorage?.getItem("idmUserName") || '');
    const metadata = {
      ...this.addProtusFormFirst?.getRawValue(),
      ...this.addProtusFormSecond?.getRawValue(),
      ...this.pageType === 'addNewProtus' && {'Incident Date': formattedIncidentDate},
      Originator: localStorage?.getItem("idmUserName") || '',
      ...this.pageType !== 'addNewProtus' && {caseNumber: this.dtcDetails?.caseNumber},
      ...this.pageType !== 'addNewProtus' && {dtc: this.dtcDetails?.dtc},
      ...this.pageType !== 'addNewProtus' && {dtcId: this.dtcDetails?.dtcId}
    };
    formData?.append('metadata', JSON.stringify(metadata));
    if (this.file) {
      formData?.append('file', this.file);
    }
    this._addProtusSubscription = this._caseService?.addProtus(formData)?.subscribe((result: any) => {
      if (result) {
        this.handleClose(false, result?.protusNumber, result?.response?.name)
        this._service?.toasterService({ type: 'success', msg: result?.message });
      } else {
        this._service.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
   * Gets date7 days forward
   * @param providedDate 
   * @returns  
   */
  getDate7DaysForward(providedDate: string) {
    const date = new Date(providedDate);
    date.setDate(date.getDate() + 7);
    return date;
  }

  /**
   * Gets add option required flag
   * @param fieldName 
   * @returns  
   */
  getAddOptionRequiredFlag(fieldName: string) {
    return this._idmConfig?.addOptionRequiredDropdownList?.find(field => field === fieldName);
  }

  /**
 * Updates configuration
 * @param event 
 */
  updateConfiguration(newOptionsList: { name: string, value: string }[] = [], configKeyName: string) {
    let configDetails = this._service?.getConfiguration('idmConfig', '');
    if (!configDetails) return;
    let updatedValues = JSON.parse(JSON.stringify(configDetails?.values));
    if (updatedValues && updatedValues?.addProtusFieldValues?.hasOwnProperty(configKeyName)) {
      updatedValues.addProtusFieldValues[configKeyName] = newOptionsList;
    }
    let formValue = {
      attribute: "idmConfig",
      attributeList: "",
      description: "Configuration for IDM",
      tenantId: localStorage.getItem('tenantId'),
      type: "tenant",
      values: updatedValues
    };

    let postData = { configurationId: configDetails['_id'], set: formValue, tab: 'tenant' };
    this._configUpdateSubscription = this._service.saveConfig(postData).subscribe((result: any) => {
      if (result['status'] && result['response']) {
        if (result['status']) {
          this._configUpdated = true;
          this._getConfiguration();
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
        } else {
          this._configUpdated = false;
          this._service.toasterService({ type: 'error', msg: result['response']['message'] + ' - ' + result['response']['error'] });
        }
      } else {
        if (result['response']) {
          this._configUpdated = false;
          this._service.toasterService({ type: 'error', msg: result['response']['message'] + ' - ' + result['response']['error'] });
        }
      }
    });
  }

  /**
   * Gets models list
   */
  private _getModelsList() {
    this._getModelsListSubscription = this._caseService?.getModelsList(this._idmConfig?.isMock ? this._idmConfig?.isMock : false)?.subscribe((result: any) => {
      if (result) {
        this.modelsList = result?.map(model => {
          return { ...model, value: model?.id };
        });
        this.isLoaderModelNo = false;
      } else {
        this.modelsList = null;
        this.isLoaderModelNo = false;
        this._service.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
   * Gets projects list
   */
  private _getProjectsList() {
    this._getProjectListSubsription = this._caseService?.getProjectsList(this._idmConfig?.isMock ? this._idmConfig?.isMock : false)?.subscribe((result: any) => {
      if (result) {
        this.projectsNameList = result?.map(project => {
          return { ...project, value: project?.id };
        });
        this.isLoaderProjectName = false;
      } else {
        this.projectsNameList = null;
        this.isLoaderProjectName = false;
        this._service.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
   * Sets drop down values from config
   */
  private _setDropDownValuesFromConfig() {
    const addProtusFieldValues = this._idmConfig ? this._idmConfig?.addProtusFieldValues : null;
    this.faultPointMapping = addProtusFieldValues?.faultPointMapping;
    this.faultPoint = addProtusFieldValues?.faultPointMapping?.find(severityItem => severityItem?.severity === this.dtcDetails?.severity)?.value;
    this.trackingProjectsList = addProtusFieldValues?.trackingProjectsList;
    this.ncTypeList = addProtusFieldValues?.ncType;
    this.affectedAggregatesList = addProtusFieldValues?.affectedAggregates;
    this.testTypeList = addProtusFieldValues?.testType;
    this.testObjectTypeList = addProtusFieldValues?.testObjectType;
    this.incidentCategoryList = addProtusFieldValues?.incidentCategory;
    if (this.faultPoint) {
      this.addProtusFormSecond?.get('Fault Point')?.disable();
    }
    this.toolPartVerificationList = addProtusFieldValues?.toolPartVerificationList;
    this.correctProcessUsedList = addProtusFieldValues?.correctProcessUsedList;
  }

  /**
 * Gets vehicle list
 * @param pageNo 
 */
  private _getEntityDetails(pageNo: number) {
    const payloadContent: Partial<EntityListPayloadModel> = {
      status: null,
      searchKey: null,
      sortBy: null,
      filterBy: null,
      operationalStatusFilter: null,
      alertsFilter: null,
      siteId: this._service.getSiteId(),
      type: 1,
      entityIds: [this.dtcDetails?.entityId ?? this.addProtusFormFirst?.get('Chassis No')?.value],
      domain: this.tenantConfig?.tenant
    };
    this._entitiesListSubscription = this._service?.entitiesList(payloadContent, pageNo, false)?.subscribe((result: any) => {
      if (result['status']) {
        this.listingDetails = (result['response']['data']?.map((item: any) => ({ ...item, isAction: false })))?.[0];
        if(this.pageType === 'addNewProtus') {
          this.teleHistoryConfig = this._service.getConfigurationBasedOnCategory(this.listingDetails) ?
          this._service.getConfigurationBasedOnCategory(this.listingDetails) : [];
        }
        this._patchVehicleDetails();
      } else {
        this.listingDetails = null;
        this._service.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
   * Patchs vehicle details
   */
  private _patchVehicleDetails() {
    this.addProtusFormFirst?.get('Chassis No')?.setValue(this.listingDetails?.uniqueId);
    this.addProtusFormFirst?.get('Vehicle Name')?.setValue(this.listingDetails?.name);
    this.addProtusFormFirst?.get('Incident Related WheelBase')?.setValue(this.listingDetails?.secondaryDetails?.wheelBase);
    this.addProtusFormFirst?.get('Build Number')?.setValue(this.listingDetails?.secondaryDetails?.buildNumber);
    this.addProtusFormFirst?.get('Release Build')?.setValue(this.listingDetails?.secondaryDetails?.buildType);
    this.addProtusFormSecond?.get('Incident Date')?.setValue(new DatePipe('en-US')?.transform(this.dtcDetails?.metadata?.createdDate, 'MM/dd/yyyy'));
    this.addProtusFormSecond?.get('Fault Point')?.setValue(this.faultPoint)
  }

  /**
 * Gets configuration
 */
  private _getConfiguration() {
    let mappedConfigList = [];
    this._configurationsInfoSubscription = this._service.configurationsInfo(masterConfigurationList).subscribe({
      next: (data: any) => {
        if (data.status && data.response.length) {
          mappedConfigList = data.response.map((item: any) => {
            const obj = {};
            obj['attribute'] = item.attribute;
            obj['values'] = item.values;
            obj['_id'] = item._id;
            return obj;
          });
          this._service.setConfiguration(mappedConfigList);
        } else {
          this._service.setConfiguration(mappedConfigList);
        }
        if (!mappedConfigList.length) {
          this._service.toasterService({
            type: 'warning',
            msg: 'Configuration list is not available, please provide the required configuration for the app'
          });
        }
      },
      error: (error) => {
      }
    });
  }
}
